'use client';
import React from 'react';
import { Switch, FormControlLabel, Typography } from '@mui/material';

interface NotificationToggleProps {
  label: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const NotificationToggle: React.FC<NotificationToggleProps> = ({ label, checked, onChange }) => (
  <FormControlLabel
    control={<Switch checked={checked} onChange={onChange} color="primary" />}
    label={
      <Typography variant="button-m" className="font-semibold">
        {label}
      </Typography>
    }
  />
);

export default NotificationToggle;
